export const companyConfig = {
  shortName: "Stockerra",
  legalName: "Denborgin Software",
  wmsName: "Stockerra Docs",
  addressLines: ["ul. Zolnierzy 2 Armii", "65-936 Zielona Góra, Polska"],
  taxId: "NIP PL 779 243 02 24",
  regon: "Regon 362932912",
  krs: "KRS 0000585289",
  phoneFax: "+48 68 321 33 14, fax +48 68 321 34 61",
  email: "contact@denborgin.com",
  website: "www.denborgin.com",
  assets: {
    loginLogo: "/assets/images/stockerra_logo.png",
    labelLogo: "/assets/images/stockerra_logo.png",
  },
  alt: {
    loginLogo: "Stockerra WMS logo",
    labelLogo: "Stockerra WMS logo",
  },
} as const
